import { Injectable } from '@angular/core'

import { Observable, catchError, map, of } from 'rxjs'

import {
  GetBiztelAccountMappingsGQL,
  GetBiztelAccountMappingsQuery,
  ImportBiztelAccountMappingGQL,
  ImportBiztelAccountMappingMutation,
} from '../../../../_generated/graphql'
import { assertGraphqlData } from '../../../util/assertGraphqlData'
import { throwIfCustomError } from '../../../util/throwIfCustomError'

export type BiztelAccountMappingView =
  GetBiztelAccountMappingsQuery['getAdminOrg']['biztelAccountMappings'][number]

export type ImportBiztelAccountMappingResultView =
  ImportBiztelAccountMappingMutation['importBiztelAccountMapping']

@Injectable({
  providedIn: 'root',
})
export class BiztelAccountMappingService {
  constructor(
    private getBiztelAccountMappingsGQL: GetBiztelAccountMappingsGQL,
    private importBiztelAccountMappingGQL: ImportBiztelAccountMappingGQL,
  ) {}

  getBiztelAccountMappings(): Observable<BiztelAccountMappingView[]> {
    return this.getBiztelAccountMappingsGQL
      .fetch({ fetchPolicy: 'no-cache' })
      .pipe(
        map((res) => {
          assertGraphqlData(res)
          return res.data.getAdminOrg.biztelAccountMappings
        }),
      )
  }

  importBiztelAccountMapping(
    csvBase64: string,
    dryRun: boolean,
  ): Observable<ImportBiztelAccountMappingResultView | undefined> {
    return this.importBiztelAccountMappingGQL
      .mutate({ variables: { csvBase64, dryRun }, fetchPolicy: 'no-cache' })
      .pipe(
        map((res) => res.data?.importBiztelAccountMapping),
        catchError((error: unknown) => {
          throwIfCustomError(error)
          return of(undefined)
        }),
      )
  }
}
